/**
 * Phone number formatting utilities
 */

/**
 * Remove all non-numeric characters from a string
 */
export const cleanPhoneNumber = (value: string): string => {
  if (!value) return "";
  return value.replace(/\D/g, "");
};

/**
 * Format phone number as (XX) XXXXX-XXXX for Brazilian format
 */
export const formatPhoneNumber = (value: string): string => {
  if (!value) return "";
  const numbers = cleanPhoneNumber(value);

  // Format as (XX) XXXXX-XXXX
  if (numbers.length >= 11) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(
      7,
      11
    )}`;
  } else if (numbers.length >= 7) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(
      7
    )}`;
  } else if (numbers.length >= 3) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
  } else if (numbers.length >= 1) {
    return `(${numbers}`;
  }
  return numbers;
};

/**
 * Format phone number for display (complete numbers only)
 * Returns formatted phone if valid, original value if not
 */
export const displayPhoneNumber = (value: string): string => {
  if (!value) return "";
  const numbers = cleanPhoneNumber(value);

  // Only format if we have at least 10 digits (complete phone)
  if (numbers.length >= 10) {
    return formatPhoneNumber(value);
  }

  // Return original value if incomplete
  return value;
};

/**
 * Validate Brazilian phone number
 */
export const validatePhoneNumber = (
  value: string
): { isValid: boolean; error?: string } => {
  const numbers = cleanPhoneNumber(value);

  if (numbers.length < 10) {
    return {
      isValid: false,
      error: "Telefone deve ter pelo menos 10 dígitos",
    };
  }

  if (numbers.length > 11) {
    return {
      isValid: false,
      error: "Telefone não pode ter mais de 11 dígitos",
    };
  }

  return { isValid: true };
};

/**
 * Handle phone input change with formatting
 */
export const handlePhoneInputChange = (
  value: string,
  onChange: (formattedValue: string) => void
): void => {
  const formatted = formatPhoneNumber(value);
  onChange(formatted);
};
